<script>
	import { convertDateTime } from "src/services/helpers";
</script>

<span class="on-surface-variant" style="text-align: end; white-space: nowrap"
	>Last updated
	{convertDateTime(new Date(), "MMM D, h:mm A")}
</span>
